import React from 'react';
import { Button } from 'react-admin';
import { RemoveCircleOutline } from '@material-ui/icons';

const CustomRemoveButton = (props) => {
    return (
        <Button
            label="ВИДАЛИТИ"
            {...props}
        >
            <RemoveCircleOutline />
        </Button>
    );
};

export default CustomRemoveButton;
